var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9318 7.53201C17.3227 7.14112 17.9567 7.14112 18.3476 7.53201C18.7385 7.92304 18.7385 8.55709 18.3476 8.94798L10.8282 16.4677C10.4372 16.8586 9.80313 16.8586 9.41223 16.4677L5.65238 12.7079C5.26149 12.317 5.26149 11.6829 5.65238 11.292C6.04341 10.901 6.67745 10.901 7.06835 11.292L10.1202 14.3439L16.9318 7.53201ZM11.9999 0C15.3132 0 18.3135 1.34338 20.4851 3.51497C22.6566 5.68642 24 8.68689 24 12C24 15.3136 22.6568 18.3136 20.4851 20.4852C18.3135 22.6568 15.3132 24.0001 11.9999 24.0001C8.68644 24.0001 5.68639 22.6569 3.51495 20.4852C1.3431 18.3136 0 15.3136 0 12C0 8.68689 1.34337 5.68642 3.51495 3.51497C5.68639 1.34311 8.68644 0 11.9999 0ZM19.0692 4.9308C17.2602 3.12191 14.7608 2.00292 11.9999 2.00292C9.23898 2.00292 6.73952 3.12191 4.93078 4.9308C3.12189 6.73969 2.00291 9.2393 2.00291 12C2.00291 14.7611 3.12189 17.2606 4.93078 19.0693C6.73952 20.8782 9.23898 21.9971 11.9999 21.9971C14.7608 21.9971 17.2602 20.8782 19.0692 19.0693C20.8781 17.2606 21.997 14.7611 21.997 12C21.997 9.2393 20.8781 6.73969 19.0692 4.9308Z",
    fill: "#558564"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c66421841a55e509d3e6b4746808b7e9.svg";
export { ForwardRef as ReactComponent };